<template>
  <div>
    <Head :title="__(title)" />
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="store">
        <div class="flex flex-wrap -mb-8 -mr-6 p-8">
          <text-input 
            v-model="form.name" 
            :error="form.errors.name" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Name')" 
            required
          />
          <select-input 
            v-model="form.status" 
            :error="form.errors.status" 
            class="pb-8 pr-6 w-full lg:w-1/2"
            :label="__('Status')">
            <option :value="true">{{ __('Active') }}</option>
            <option :value="false">{{ __('Inactive') }}</option>
          </select-input>
          <textarea-input 
            v-model="form.description" 
            :error="form.errors.description" 
            class="pb-8 pr-6 w-full"
            :label="__('Description')" 
          />
        </div>
        <div class="flex items-center justify-end px-8 py-4 bg-gray-50 border-t border-gray-100">
          <loading-button :loading="form.processing" class="btn-indigo" type="submit">
            {{ __('Create Category') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
import LoadingButton from '@/Shared/LoadingButton'

export default {
  components: {
    Head,
    Link,
    LoadingButton,
    SelectInput,
    TextInput,
    TextareaInput,
  },
  layout: Layout,
  props: {
    title: String,
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        name: '',
        description: '',
        status: true,
      }),
    }
  },
  methods: {
    store() {
      this.form.post(this.route('student-categories.store'))
    },
  },
}
</script>
